module.exports = __WEBPACK_EXTERNAL_MODULE_dr12__;